"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
const react_1 = __importDefault(require("react"));
const useStyles = (0, makeStyles_1.default)((theme) => ({
    box: {
        backgroundColor: theme.palette.primary.main,
        color: "white",
        textShadow: "0.01em 0 rgba(0, 0, 0, 0.2),0 0.01em rgba(0, 0, 0, 0.2),-0.01em 0 rgba(0, 0, 0, 0.2),0 -0.01em rgba(0, 0, 0, 0.2)",
    },
}));
function Title({ children }) {
    const classes = useStyles();
    return (react_1.default.createElement(material_1.Box, { className: classes.box, pr: 8, pl: 8, pt: 8, pb: 8 }, children));
}
exports.default = Title;
